import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { VistoCorridoRequest, VistoCorridoResponse } from './visto-corrido.model';

@Injectable({ providedIn: 'root' })
export class VistoCorridoService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.pessoaFisica.vistoCorrido;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultar(params: VistoCorridoRequest, context?: HttpContext): Observable<VistoCorridoResponse> {
        let httpParams = new HttpParams().set('numeroProtocolo', params.numeroProtocolo).set('anoProtocolo', params.anoProtocolo).set('uf_crm', params.ufCrm);
        if (params.codigoServico) {
            httpParams = httpParams.set('codigoServico', params.codigoServico);
        }
        return this.http.get<VistoCorridoResponse>(this.PATH, { params: httpParams, context });
    }

    consultarAbertos(ufCrm: string, codigoServico?: string, context?: HttpContext): Observable<Record<string, unknown>[]> {
        let httpParams = new HttpParams().set('uf_crm', ufCrm);
        if (codigoServico) {
            httpParams = httpParams.set('codigoServico', codigoServico);
        }
        return this.http.get<Record<string, unknown>[]>(`${this.PATH}/abertos`, { params: httpParams, context });
    }
    efetivarSolicitacao(dto: VistoCorridoResponse, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/efetivarSolicitacao`, dto, { context });
    }

    cancelarSolicitacao(dto: VistoCorridoResponse, motivo?: string, context?: HttpContext): Observable<void> {
        const params = motivo ? new HttpParams().set('motivo', motivo) : undefined;
        return this.http.put<void>(`${this.PATH}/cancelarSolicitacao`, dto, { params, context });
    }
}
